import type { ReactElement, CSSProperties } from 'react'
import { STROKE } from '../glyphs/shared'

interface PetalProps {
  size?: number
  color?: string
  style?: CSSProperties
}

/**
 * Sakura petal silhouette. Wrap in an absolutely-positioned div with
 * the .petal utility class for the drifting animation.
 */
export const Petal = ({
  size = 18,
  color = '#ffb3c1',
  style,
}: PetalProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={style}>
    <path
      d="M12 2 C 18 6 18 14 12 22 C 6 14 6 6 12 2 Z"
      fill={color}
      stroke={STROKE}
      strokeWidth="1.2"
    />
  </svg>
)
